import {
  alpha,
  Button,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import ForumIcon from '@material-ui/icons/Forum';
import { useModal } from 'react-modal-hook';

import ModalEnviarMensagemDeTag from './ModalEnviarMensagemDeTag';

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: palette.text.secondary,
    marginBlock: spacing(1),
  },

  sendTemplateButton: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    padding: spacing(1, 0),
    backgroundColor: palette.background.paper,
    color: palette.text.primary,

    '& > .MuiButton-label': {
      gap: spacing(1),
    },

    '&:hover': {
      backgroundColor: alpha(palette.action.hover, 0.1),
    },
  },
}));

interface ButtonSendTagMessageProps {
  onSendInstagramTagMessage: (
    value: string,
    callback: (isSuccess: boolean) => void,
  ) => void;
}

export default function ButtonSendTagMessage({
  onSendInstagramTagMessage,
}: ButtonSendTagMessageProps) {
  const classes = useStyles();

  const [showModalEnviarMensagemDeTag, hideModalEnviarMensagemDeTag] = useModal(
    ({ in: open }) => {
      return (
        <ModalEnviarMensagemDeTag
          open={open}
          onClose={hideModalEnviarMensagemDeTag}
          onSendInstagramTagMessage={onSendInstagramTagMessage}
        />
      );
    },
    [],
  );

  return (
    <Paper className={classes.root} elevation={0}>
      <Button
        variant="contained"
        className={classes.sendTemplateButton}
        onClick={showModalEnviarMensagemDeTag}
      >
        <ForumIcon color="primary" />
        <Typography variant="body2">Enviar Mensagem de Tag</Typography>
      </Button>
    </Paper>
  );
}
